import React, { useEffect, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { Redirect, useHistory, useParams } from 'react-router';
import { addReview, fetchReview } from '../../redux/actions/review';
import AddReviewModal from '../review/AddReviewModal';
import { connect } from 'react-redux';
import axios from 'axios';
import hasWallet from '../../helpers/authServices';
import { fetchProjectById } from '../../redux/actions/project';
import Rating from '../rating/Rating';


const  ItemDetails =({dispatch, data, reviews}) => {
    const [modalShow, setModalShow] = useState(false);
    const [changedField, setChangedField] = useState({ rating:'', risk:'', comment:''});
    const [magiceden, setMagicEden] = useState({ });
    const [project, setProject] = useState();
  const [modalType] = useState('add');

  const { addToast } = useToasts();
  const {  id } = useParams();
  let totalReview=0;
 

totalReview= reviews.reduce((accumulator, object) => {
    return (accumulator + object.rating);
  },0);
totalReview/=reviews.length;


const formatNum = n => {
    if(n<1e6) return n;
      n= (n/1e9);
      if (n < 1e3) return n.toFixed(2) + " SOL";
      if (n >= 1e3 && n < 1e6) return +(n/1e3).toFixed(1) + "K SOL";
      if (n >= 1e6 && n < 1e9) return +(n/1e6).toFixed(1) + "M SOL";
    };
 
  useEffect(()=>{
    dispatch(fetchReview(id))
    dispatch(fetchProjectById(id)).then(res=>{
        setProject(res)
      
       axios.get(`https://nft-review-server.vercel.app/magicedendataMainnet/${(res.megiceden.split('marketplace/')[1])}`)
.then(function (response) {

setMagicEden(response.data)
})
.catch(function (error) {
  console.log(error);
});
    })




  },[])
const history= useHistory()

  const handleAddReview= async () => {
    // dispatch(addReview(changedField,id, addToast))
    const wallet= await hasWallet(localStorage.getItem('wallet'))
    if (!wallet) {
       
        history.push('/wallteconnect')
        return}
  setModalShow(true)
  }
 
  const toggleModal = () => setModalShow(!modalShow);

  const handleSubmit= async()=>{
    const wallet= localStorage.getItem('wallet')
    if (!wallet) {
        return (
          <Redirect to='/wallteconnect' />
        )}
    dispatch(addReview({id,wallet, review:changedField.comment,rating: changedField.rating,risk:changedField.risk}, addToast ))
    setModalShow(false)
  }
    
    
        return (
            <section className="item-details-area mt-5">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-12 col-lg-3">
                            <div className="item-info">
                                <div className="item-thumb text-center">
                                    <img className='rounded-circle' height={180} width={150} src={project&& project.image} alt="project-img" />
                                </div>
                                
                                <h5 className="text-center mb-0 p-0">{project && project.projectname}</h5>

                                {reviews.length>0 && <div className='rating text-center'>
                                <div className='star-rating'>
                                <Rating rating={totalReview}/>
                                </div>
                                <div className="risk-rating">
                                    {totalReview>4? <span className='badge badge-success'>Low Risk</span> :
                                    totalReview>=3? <span className='badge badge-warning'>Medium Risk</span> :
                                    <span className='badge badge-danger'>High Risk</span>}
                                </div>
                                

                                </div>}
                                <p className='text-center'>{project && project.description}</p>

                                <h4 className="m-0 ">Summary</h4>
                               {project&& project.summary&& project.summary[0].split(',').map((item,indx)=>(
                                
                                <div key={indx}>
                                    <li>{item}</li>
                                </div>
                                
                               ))}
                                

                                <div className='d-flex justify-content-center'>
                                   
                                    <button onClick={handleAddReview} className="btn btn-add  mt-3 mt-sm-4" ><i className="icon-plus mr-2" />Add Review</button>
                                </div>
                                
                            </div>
                        </div>
                        <div className="col-12 col-lg-9">
                            {/* Content */}
                            <div className="content mt-lg-0">
                              <div className='row items'>
                               
                             
                             <div  className="col-12 col-sm-6 col-lg-3 item">
                                   
                                   <div className="card no-hover">

                                       <div className="single-seller d-flex flex-column align-items-center ">
                                          <span>Team Status</span>
                                          <span className='text-success font-weight-bold'>{project && project.teamStatus==='1'? 'DOXXED':'UNDOXXED'}</span>
                                       </div>
                                   </div>
                               </div>
                               <div  className="col-12 col-sm-6 col-lg-3 item">
                                 
                                   <div className="card no-hover">

                                       <div className="single-seller d-flex flex-column align-items-center ">
                                          <span>Utilities</span>
                                          <span className='text-success font-weight-bold'>{project && project.utilities==='1'? 'YES':'NO'}</span>
                                       </div>
                                   </div>
                               </div>

                               <div  className="col-12 col-sm-6 col-lg-3 item">
                                  
                                  <div className="card no-hover">

                                      <div className="single-seller d-flex flex-column align-items-center ">
                                         <span>Twitter Followers</span>
                                         <span className='font-weight-bold'>{project&& project.twitterFollowers? project.twitterFollowers :'N/A'}</span>
                                      </div>
                                  </div>
                              </div>
                              <div  className="col-12 col-sm-6 col-lg-3 item">
                                
                                  <div className="card no-hover">

                                      <div className="single-seller d-flex flex-column align-items-center ">
                                         <span>Discord</span>
                                         <span className='font-weight-bold'>{project&& project.discordMember}</span>
                                      </div>
                                  </div>
                              </div>


                           <div className="row col-12 mt-4 mb-0">
                           <p>Mint Details</p>
                           </div>
                              <div  className="col-12 col-sm-6 col-lg-3 mt-2">
                                   
                                   <div className="card no-hover">

                                       <div className="single-seller d-flex flex-column align-items-center ">
                                          <span>Mint price</span>
                                          <span className='font-weight-bold'>{project && project.mintPrice}</span>
                                       </div>
                                   </div>
                               </div>
                               <div  className="col-12 col-sm-6 col-lg-3 mt-2">
                                 
                                   <div className="card no-hover">

                                       <div className="single-seller d-flex flex-column align-items-center ">
                                          <span>Unique Holder</span>
                                          <span className=' font-weight-bold'>N/A</span>
                                       </div>
                                   </div>
                               </div>

                               <div  className="col-12 col-sm-6 col-lg-3 mt-2">
                                  
                                  <div className="card no-hover">

                                      <div className="single-seller d-flex flex-column align-items-center ">
                                         <span>Collection Size</span>
                                         <span className=' font-weight-bold'>{project&& project.collectionSize}</span>
                                      </div>
                                  </div>
                              </div>
                              <div  className="col-12 col-sm-6 col-lg-3 mt-2">
                                
                                  <div className="card no-hover">

                                      <div className="single-seller d-flex flex-column align-items-center ">
                                         <span>Mint Rev</span>
                                         <span className='font-weight-bold'>{project && project.mintRevenue}</span>
                                      </div>
                                  </div>
                              </div>
                            
                                

                            
                            </div> 
                            

                                 {/* statistics */}
                                 <h4 className='text-center mt-5'> Magic Eden Stats</h4>
                                 <div className="row from-edenmagic justify-content-center ">
                                    
                                <div  className="col-12 col-sm-6 col-lg-3 mt-2">
                                
                                <div className="card no-hover">

                                    <div className="single-seller d-flex flex-column align-items-center ">
                                       <span>Average Price</span>
                                       <span className='font-weight-bold'>{magiceden.avgPrice24hr? formatNum(magiceden.avgPrice24hr): 'N/A'}</span>
                                    </div>
                                </div>
                            </div>

                                <div  className="col-12 col-sm-6 col-lg-3 mt-2">
                                
                                <div className="card no-hover">

                                    <div className="single-seller d-flex flex-column align-items-center ">
                                       <span>Floor Price</span>
                                       <span className='font-weight-bold'>{magiceden.floorPrice? formatNum(magiceden.floorPrice): 'N/A'}</span>
                                    </div>
                                </div>
                            </div>

                            <div  className="col-12 col-sm-6 col-lg-3 mt-2">
                                
                                  <div className="card no-hover">

                                      <div className="single-seller d-flex flex-column align-items-center ">
                                         <span>List Count</span>
                                         <span className='font-weight-bold'>{magiceden.listedCount ? formatNum(magiceden.listedCount) : 'N/A'}</span>
                                      </div>
                                  </div>
                              </div>

                              <div  className="col-12 col-sm-6 col-lg-3 mt-2">
                                
                                  <div className="card no-hover">

                                      <div className="single-seller d-flex flex-column align-items-center ">
                                         <span>Volume</span>
                                         <span className='font-weight-bold'>{magiceden.volumeAll ?formatNum(magiceden.volumeAll) : 'N/A'}</span>
                                      </div>
                                  </div>
                              </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>


                    {modalShow && <AddReviewModal  show={modalShow} changedField={changedField} setChangedField={setChangedField} modalType={modalType} toggle={toggleModal} handleSubmit={handleSubmit}/>}

                </div>
                
      
            </section>
            
        );
 }                           


 function mapStateToProps(state) {
    return {
      isAuthenticated: state.auth.isAuthenticated,

      data: state.project.projectData,
      reviews: state.review.reviewData
    };
  }

  export default connect(mapStateToProps)(
    ItemDetails
  );